import React from "react";
import { ReEvent } from "../../interfaces/types";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface EventCardProps {
  event: ReEvent;
}

const EventCard: React.FC<EventCardProps> = ({ event }) => {
  const navigate = useNavigate();

  return (
    <Grid item xs={12} sm={6} md={4} data-testid="event-card">
      <Card
        sx={{
          width: 345,
          minHeight: 400,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          cursor: "pointer",
          boxShadow: (theme) => `2px 2px 8px 1px ${theme.palette.primary.main}`,
        }}
        onClick={(e) => {
          navigate("/event/" + event.id);
        }}
      >
        <CardMedia
          component="img"
          sx={{ height: 140, objectFit: "scale-down", paddingTop: 3 }}
          image={event.eventConfiguration.logoUrl}
          alt="Logo"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div" align="center">
            {event.name.length > 15
              ? `${event.name.substring(0, 15)}...`
              : event.name}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {event.description.length > 150
              ? `${event.description.substring(0, 150)}...`
              : event.description}
          </Typography>
        </CardContent>
        <CardActions
          sx={{
            justifyContent: "center",
            marginTop: "auto",
            width: "100%",
            paddingBottom: 2,
          }}
        >
          {/*<Button size="small" variant="outlined">
          Share
            </Button>*/}

          {event.id && (
            <Button
              size="large"
              variant="outlined"
              onClick={(e) => e.stopPropagation()}
              fullWidth
              sx={{ height: "100%", padding: 0, marginLeft: 2, marginRight: 4 }}
            >
              <a
                href={`/event/${event.id}`}
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                  padding: "8px 16px",
                  boxSizing: "border-box",
                  textAlign: "center",
                }}
              >
                More information
              </a>
            </Button>
          )}
        </CardActions>
      </Card>
    </Grid>
  );
};

export default EventCard;
